import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogContent, DialogTitle, Box, Button, Grid, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

import moment from 'moment-timezone';

const AcceptRescheduleRequest = (props) => {
  const {closeModel, event, onRescheduleEvent} = props;
  const [isSaving, setIsSaving] = React.useState(false);

  const onSave = async (e) => {
    setIsSaving(true);
    const reschedule = event.caregiverUpdates.find((update) => update.type === 'requestReschedule');
    const rescheduledDate = reschedule.data.dateString;
    const rescheduledTime = reschedule.data.timeString;
    const rescheduleReason = reschedule.data.rescheduleReason || translate('schedule.eventDetail.EventTimelineSection.ShiftRescheduled.NoReason');

    const startTime = moment.tz(event.eventData.startTime, event.eventData.timezone);
    const endTime = moment.tz(event.eventData.endTime, event.eventData.timezone);
    const timezone = event.eventData.timezone;

    // new shift data
    const newStartTime = moment.tz(`${rescheduledDate} ${rescheduledTime}`, 'ddd MMM DD YYYY h:mm A', timezone);
    const duration = moment.duration(endTime.diff(startTime));
    const newEndTime = newStartTime.clone().add(duration);

    const reasonForException = {
      description: {
        blob: rescheduleReason,
        editorType: 'MARKDOWN',
      },
    };

    const eventData = {
      startTime: newStartTime.format(),
      endTime: newEndTime.format(),
      timezone: timezone,
    };

    await onRescheduleEvent(
        event.clientData.clientRn,
        event.eventRn,
        reasonForException,
        eventData,
        event.shiftType,
        () => {
          closeModel(true);
          setIsSaving(false);
        },
    );
  };

  const onClose = () => {
    closeModel(false);
  };

  return (
    <Dialog onClose={onClose} open={true} maxWidth="xs" fullWidth>
      <DialogTitle onClose={onClose}>
        <Translate expression='schedule.eventDetail.AcceptRescheduleDialog.Title'/>
      </DialogTitle>
      <DialogContent >
        <Grid item xs={12}>
          <Typography variant="body2" color="text.secondary">
            <Translate expression='schedule.eventDetail.AcceptRescheduleDialog.Description'/>
          </Typography>
        </Grid>
      </DialogContent>
      <Box sx={{display: 'flex', justifyContent: 'flex-end', gap: 1, p: 2}}>
        <Button variant="outlined" onClick={onClose}>
          <Translate expression="generic.Cancel" />
        </Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={isSaving}
        >
          <Translate expression="generic.Confirm" />
        </Button>
      </Box>
    </Dialog>
  );
};

AcceptRescheduleRequest.propTypes = {
  closeModel: PropTypes.func.isRequired,
  event: PropTypes.object.isRequired,
  onRescheduleEvent: PropTypes.func.isRequired,
};

export default AcceptRescheduleRequest;
